import { Component } from '@angular/core';
import { UtilityHelper } from '../../../core/helper/utility-helper';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { WebService } from '../../../core/services/web-service/web.service';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../core/services/authentication/auth.service';
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { REGEX_PATTERNS } from '../../../core/constant/data-constants';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

@Component({
  selector: 'app-contact-us',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
    HttpClientModule,
    NgxIntlTelInputModule,
  ],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss',
})
export class ContactUsComponent {
  DataList: any;
  imageBaseUrl = environment.imageBaseUrl;
  domiImageBaseUrl = environment.domiImageBaseUrl;
  isSliderInitialized = false;
  isSubmitting: boolean | undefined = false;
  constructor(
    private utility: UtilityHelper,
    private router: Router,
    private WebService: WebService,
    private fb: FormBuilder
  ) {}
  ngOnInit() {
    this.getSiteSettingData();
  }
  getSiteSettingData() {
    this.WebService.getSiteSetting().subscribe((response: any) => {
      if (response.status == 200) {
        this.DataList = response.data;
        this.WebService.setSettingData(response);
      } else {
        this.DataList = '';
      }
    });
  }
  contactUs = this.fb.nonNullable.group({
    full_name: [
      '',
      [Validators.required, Validators.pattern(REGEX_PATTERNS.alphabetsOnly)],
    ],
    email: [
      '',
      [Validators.required, Validators.pattern(REGEX_PATTERNS.email)],
    ],
    description: [
      '',
      [Validators.required, Validators.pattern(REGEX_PATTERNS.address)],
    ],
  });
  get f() {
    return this.contactUs.controls;
  }
  contactUsUser() {
    if (this.contactUs.invalid) {
      Object.values(this.contactUs.controls).forEach((control) => {
        control.markAsTouched();
      });
      return;
    }
    this.isSubmitting = true;
    let req = this.contactUs.value;
    this.WebService.contactUs(req).subscribe({
      next: (res) => {
        if (res.status === 200) {
          this.isSubmitting = false;
          this.utility.toastAlert('success', res.message);
          this.contactUs.reset();
          // this.contactUs.patchValue({ full_name: '' ,email: '' ,description: '' });
        } else {
          this.utility.toastAlert('error', res.message);
          this.isSubmitting = false;
        }
      },
      error: (error: any) => {
        this.isSubmitting = false;
        const errorMessage = error.message || 'An unexpected error occurred';
        this.utility.toastAlert('error', errorMessage);
      },
    });
  }
}
